import { apiSlice } from '../app/api/apiSlice'

export const assigneeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listAssignees: builder.query ({
      query: () => `v2/assignees/`,
    }),
  }),
})

export const {
    useListAssigneesQuery,
} = assigneeApi;
